export const dnGraphQlClient = Symbol("dnGraphlQlClientSymbol");
